module.exports = __webpack_public_path__ + "static/media/burger_family_deals-dt-en.21dac9ad.jpg";